export default __webpack_public_path__ + "static/media/eclinic_specialties_logo_poli.1f5ec78e.svg";